import { getArtisanCharacteristics, ui } from '@utils/i18n/uiCopy'

/** Características artesanales en el idioma de la interfaz (es por defecto). */
export function getBudgetArtisanCharacteristics(): string[] {
  return getArtisanCharacteristics()
}

export function buildArtisanCharacteristicsHtml(escapeHtml: (value: string) => string): string {
  const paragraphs = getBudgetArtisanCharacteristics().map(
    (text) => `<p class="characteristics-text">${escapeHtml(text)}</p>`,
  ).join('')

  return `<div class="characteristics-block">
    <div class="line"><span class="label-strong">${escapeHtml(ui('characteristics'))}:</span></div>
    ${paragraphs}
  </div>`
}
